import { animated, useSpring } from '@react-spring/three';

import TitleInnovation from './models/TitleInnovation';

function TitleAnimation() {
  const { position } = useSpring({
    to: {
      position: -30,
    },
    from: { position: -900 },
    config: {
      mass: 3, tension: 100, friction: 34, precision: 0.02,
    },
  });
  return (
    <animated.mesh position={position}>
      <TitleInnovation />
    </animated.mesh>
  );
}

export default TitleAnimation;
